import React, { useState, useEffect } from 'react';
import NavBar from './components/NavBar';
import HomePage from './components/pages/HomePage';
import ShopPage from './components/pages/ShopPage';
import InstagramPage from './components/pages/InstagramPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Cart from './components/Cart';
import './styles/global.css';
import { setViewportHeight } from './utils/viewport';

const App = () => {
  const [activePage, setActivePage] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Update global flag and viewport settings when active page changes
  useEffect(() => {
    // Update global flag
    window.isHomePage = activePage === 'home';
    // Update viewport height with force scroll for non-home pages
    setViewportHeight(!window.isHomePage);
  }, [activePage]);

  // Scroll effect for animated elements
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.8;
        if (isVisible) {
          el.classList.add('animate-visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activePage]);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/" element={
            <div className="min-h-screen flex flex-col">
              <NavBar 
                activePage={activePage} 
                setActivePage={setActivePage} 
                isMenuOpen={isMenuOpen} 
                toggleMenu={toggleMenu} 
              />
              
              {activePage === 'home' && <HomePage setActivePage={setActivePage} />}
              {activePage === 'shop' && <ShopPage />}
              {activePage === 'instagram' && <InstagramPage />}
            </div>
          } />
        </Routes>
      </Router>
    </CartProvider>
  );
};

export default App;